import type { ChangeEvent, Dispatch, SetStateAction } from 'react';

import { Flex, Input } from '@pega/cosmos-react-core';

export const FormRenderer = ({
  firstName,
  onFirstNameChange,
  lastName,
  onLastNameChange
}: {
  firstName: string;
  onFirstNameChange: Dispatch<SetStateAction<string>>;
  lastName: string;
  onLastNameChange: Dispatch<SetStateAction<string>>;
}) => {
  return (
    <Flex container={{ gap: 1 }}>
      <Input
        label='First name'
        value={firstName}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onFirstNameChange(e.target.value)}
      />
      <Input
        label='Last name'
        value={lastName}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onLastNameChange(e.target.value)}
      />
    </Flex>
  );
};
